import React from 'react';
import PropTypes from 'prop-types';
import PaymentType from "../Display/PaymentType";


import Date from "components/Display/ViewDate";
import YesNo from "components/Display/YesNo";


const GeneralSettingTable = ({ data }) => {

  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }

  let setting = data;
  return (
    <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left calc-setting-table-header">Almennar stillingar</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th className="text-right">Kröfunúmer</th>
            <td className="text-right">{setting.claimNumber}</td>
          </tr>
          <tr>
            <th className="text-right">Innheimtubyrjun</th>
            <td className="text-right"><Date data={setting.collectionStart}/></td>
          </tr>
          <tr>
            <th className="text-right">Greiðsluráðstöfun (á kröfuhafa) <br/> Ef skuldabréf = Elsti gjalddagi fyrst</th>
            <td className="text-right"><PaymentType data={setting.paymentDistributionRule}/></td>
          </tr>
          <tr>
            <th className="text-right">Höfuðstólsfæra vexti<br/> (Reikna vaxtavexti)</th>
            <td className="text-right"><YesNo data={setting.capitalizeInterests}/> </td>
          </tr>
          <tr>
            <th className="text-right">Kröfuhafi er ekki FTS skilaskylda</th>
            <td className="text-right"><YesNo data={setting.creditorDoesNotPayCapitalTax}/></td>
          </tr>
          <tr>
            <th className="text-right">Kröfuhafi er vsk skyldur aðili</th>
            <td className="text-right"><YesNo data={setting.creditorPaysVAT}/></td>
          </tr>
          <tr>
            <th className="text-right">Sleppa skil fyrir FTS til lögmanns</th>
            <td className="text-right"><YesNo data={setting.skipCollectionCapitalGainTaxOnLawyer}/></td>
          </tr>
          <tr>
            <th className="text-right">Ráðstafa VSK alltaf</th>
            <td className="text-right"><YesNo data={setting.allocateVATAlways}/></td>
          </tr>
          <tr>
            <th className="text-right">Er skuldabréf</th>
            <td className="text-right"><YesNo data={setting.isBond}/></td>
          </tr>
          </tbody>
        </table>
    </div>
  );
};

GeneralSettingTable.propTypes = {
  data: PropTypes.object,
};

export default GeneralSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/GeneralSettingTable.js